// 园区状态
export const parkState = [
  {
    label: "待发布",
    value: "submited",
  },
  {
    label: "审核中",
    value: "review",
  },
  {
    label: "待修改",
    value: "modify",
  },
  {
    label: "已发布",
    value: "published",
  },
];
// 园区等级
export const parkLevel = [
  {
    label: "国家级",
    value: "nationalDev",
  },
  {
    label: "省级",
    value: "provinceDev",
  },
  {
    label: "市级",
    value: "provincialDev",
  },
  {
    label: "区县级",
    value: "districtDev",
  },
  {
    label: "乡镇/街道级",
    value: "townshipDev",
  },
  {
    label: "村/社区级",
    value: "villageDev",
  },
];

export default {
  parkState,
  parkLevel
};
